
import { required, requiredIf } from 'vuelidate/lib/validators'
export default {
  name: 'AvailabilityAlertForm',
  props: {
    product: Object,
  },
  data() {
    return {
      form: {
        alertable_id: this.product.variant.id,
        alertable_type: 'variant',
      },
    }
  },

  validations: {
    form: { email: required },
  },

  created() {
    if (this.$auth.loggedIn) {
      this.form.email = this.$auth.user.email
    }
  },

  methods: {
    onSubmit() {
      this.$v.$touch()

      if (!this.$v.$anyError) {
        this.$alertService
          .create({ ...this.form })
          .then(() => {
            this.$swalCustomSuccess(
              this.$t(
                'components.availabilityAlertForm.votreDemandeAEtePriseEnCompte'
              ),
              this.$t(
                'components.availabilityAlertForm.vousRecevrezUnMailDesQueLeProduitSeraDisponible'
              )
            )
            this.$bvModal.hide('availabilityAlertModal')
          })
          .catch(error => {
            this.$swalErrorMessage(error)
          })
      }
    },
  },
}
